import { render, staticRenderFns } from "./PlusButton.vue?vue&type=template&id=feb11b14&scoped=true"
import script from "./PlusButton.vue?vue&type=script&lang=js"
export * from "./PlusButton.vue?vue&type=script&lang=js"
import style0 from "./PlusButton.vue?vue&type=style&index=0&id=feb11b14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb11b14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feb11b14')) {
      api.createRecord('feb11b14', component.options)
    } else {
      api.reload('feb11b14', component.options)
    }
    module.hot.accept("./PlusButton.vue?vue&type=template&id=feb11b14&scoped=true", function () {
      api.rerender('feb11b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/PlusButton.vue"
export default component.exports